import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-coinActiveETH",
  "use": "icon-coinActiveETH-usage",
  "viewBox": "0 0 11.682 19.024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 11.682 19.024\" id=\"icon-coinActiveETH\">\n  <defs>\n    <linearGradient id=\"icon-coinActiveETH_linear-gradient\" x1=\"0.5\" y1=\"1\" x2=\"0.5\" gradientUnits=\"objectBoundingBox\">\n      <stop offset=\"0\" stop-color=\"#5660e4\" />\n      <stop offset=\"1\" stop-color=\"#51a8e2\" />\n    </linearGradient>\n  </defs>\n  <path id=\"icon-coinActiveETH_联合_88\" data-name=\"联合 88\" d=\"M0,10.8l5.839,3.45,5.842-3.45L5.839,19.024ZM0,9.689,5.839,0l5.838,9.689L5.839,13.14Z\" transform=\"translate(0)\" fill=\"url(#icon-coinActiveETH_linear-gradient)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/coinActiveETH.svg
// module id = M+Pz
// module chunks = 102